<!--
    Summary:
        hkml.exhibition.web - p5-strategy
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-p5-strategy" title="p5-strategy">
    <div class="header">
      <h2>{{$t('YDnaTest.p5_title')}}</h2>
    </div>
    <div class="content">
      <div class="box">
        <div class="th">
          {{$t('YDnaTest.p5_1_1')}}
        </div>
        <div class="td">
          <p>{{$t('YDnaTest.p5_1_2')}}</p>
          <p>{{$t('YDnaTest.p5_1_3')}}</p>
        </div>
      </div>
      <div class="box">
        <div class="th">
          {{$t('YDnaTest.p5_2_1')}}
        </div>
        <div class="td">
          <p>{{$t('YDnaTest.p5_2_2')}}</p>
          <p>{{$t('YDnaTest.p5_2_3')}}</p>
        </div>
      </div>
      <div class="box">
        <div class="th">
          {{$t('YDnaTest.p5_3_1')}}
        </div>
        <div class="td">
          <p>{{$t('YDnaTest.p5_3_2')}}</p>
          <p>{{$t('YDnaTest.p5_3_3')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p5-strategy"
  }
</script>

<style scoped lang="scss">
  .en .v-y-dna-test .v-p5-strategy{
    .content{
      .box{
        .td{
          font-size: 1.4vw;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .v-p5-strategy {
    text-align: center;
    padding: 4vw 8vw 2vw;
    .header{
      margin-bottom: 2.5vw;
      h2{
        color: #273a63;
        font-size: 2.66vw;
        font-weight: bold;
      }
    }
    .content{
      display: flex;
      .box{
        margin-right: 3px;
        font-size: 1.77vw;
        flex-grow: 1;
        &:last-child{
          margin-right: 0;
        }
        .th{
          background: #273a63;
          color: #ffffff;
          padding: 1.46vw 0;
        }
        .td{
          padding: 2vw .3vw;
          p:first-child{
            margin-bottom: 1.25vw;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p5-strategy.vue